<template>
  <div>
    <div v-if="!edit">
      <el-container>
        <SsgMessagebox
          titles="款项金额"
          v-if="maskshow && masktype == 'money'"
          @sub="onmoney"
          width="500px"
          height="auto"
          @shut="onshuts"
        >
          <div class="mtitle">请填写您收到的款项金额</div>
          <div class="minput">
            <el-input v-model="money" type="number"></el-input>
            <span class="left">￥</span>
            <span class="right">元</span>
          </div>
        </SsgMessagebox>
        <div v-if="messageshow">
          <div class="message red" v-if="authState == -1 || authState == 0">
            <div class="info">
              <div class="icon warning"></div>
              <div class="p">
                您尚未认证企业，部分业务功能只能面向认证后的企业用户开放
              </div>
              <div class="a" v-if="authzEnable" @click="toIndex">
                马上认证企业
              </div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message red" v-if="authState == 3 || authState == 8">
            <div class="info">
              <div class="icon warning"></div>
              <div class="p">{{ mname }}，认证失败</div>
              <div class="a" v-if="authzEnable" @click="renewAuth(1)">
                马上重新认证企业
              </div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message yellor" v-if="authState == 2">
            <div class="info">
              <div class="p">{{ mname }}，打款中</div>
              <div class="a" @click="oncompany">提交金额</div>
              <div class="a" v-if="authzEnable" @click="renewAuth(1)">
                重新认证
              </div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message red" v-if="authState == 4 || authState == 5">
            <div class="info">
              <div class="icon key"></div>
              <div class="p">
                我们已经向您公司的账户打了一笔随机数的款项，请将收到的款项数额反馈给我们
              </div>
              <div class="a" v-if="authzEnable" @click="oncompany">
                提交金额
              </div>
              <div class="a" v-if="authzEnable" @click="renewAuth(1)">
                重新认证
              </div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message yellor" v-if="authState == 7">
            <div class="info">
              <div class="p">{{ mname }} 线下审核认证中</div>
              <div class="a" @click="amount">查看</div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message yellor" v-if="authState == 1">
            <div class="info">
              <div class="p">{{ mname }} 审核认证中</div>
              <div class="a" v-if="authzEnable" @click="renewAuth(1)">
                重新认证
              </div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message green" v-if="false">
            <div class="info">
              <div class="p">
                您需要去
                <span class="a">设置公司印章</span>，才能为您开启电子签功能
              </div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </div>
        <el-header v-if="!edd" style="padding: 0" height="63px">
          <div class="header">
            <div class="logo" style="margin-left: 50px">
              <img :src="imgM"/>             
            </div>
            <span class="line"></span>
            <span class="serve">人力服务平台</span>

            <div id="co_pe">
              <div class="company"></div>
              <div class="personal">
                <div class="company">
                  <span>{{ currentCompany }}</span>
                  <span class="line"></span>
                  <div class="companylist"></div>
                </div>
                <div
                  class="news"
                  @mouseover="msg_show"
                  @mouseleave="msg_hidden"
                >
                  <el-badge
                    :value="noReadMsgCount"
                    class="item"
                    v-if="noReadMsgCount > 0"
                  >
                    <i class="el-icon-bell"></i>
                  </el-badge>
                  <i class="el-icon-bell" v-if="!noReadMsgCount > 0"></i>
                  <div
                    class="card"
                    v-if="msgShow"
                    @mouseover="msg_show"
                    @mouseleave="msg_hidden"
                  >
                    <div class="message_header">
                      <span class="header_title">消息中心</span>
                      <span class="header_operate">
                        <span class="mark_read" @click="markAsRead"
                          >全部标为已读</span
                        >
                        <span
                          style="font-size: 14px; padding: 0 2px"
                          v-if="false"
                          >|</span
                        >
                        <span class="message_set" v-if="false">设置</span>
                      </span>
                    </div>
                    <div class="message_content" v-if="messageList">
                      <div
                        class="message_section"
                        v-for="(v, k) in messageList"
                        :key="k"
                      >
                        <div class="message_topContent">
                          <el-badge is-dot class="item" v-if="v.status == 1">
                            <img
                              src="../../assets/img/system_notice.png"
                              alt
                              class="message_icon"
                              v-if="v.type == 1"
                            />
                            <img
                              src="../../assets/img/system_msg.png"
                              alt
                              class="message_icon"
                              v-if="v.type == 2"
                            />
                            <img
                              src="../../assets/img/system_announcement.png"
                              alt
                              class="message_icon"
                              v-if="v.type == 3"
                            />
                          </el-badge>
                          <img
                            src="../../assets/img/system_notice.png"
                            alt
                            class="message_icon"
                            v-if="v.status != 1 && v.type == 1"
                          />
                          <img
                            src="../../assets/img/system_msg.png"
                            alt
                            class="message_icon"
                            v-if="v.status != 1 && v.type == 2"
                          />
                          <img
                            src="../../assets/img/system_announcement.png"
                            alt
                            class="message_icon"
                            v-if="v.status != 1 && v.type == 3"
                          />
                          <div class="message_type">
                            <div class="system_name">
                              <span
                                >{{ v.type == 1 ? "通知" : ""
                                }}{{ v.type == 2 ? "系统消息" : ""
                                }}{{ v.type == 3 ? "系统公告" : "" }}</span
                              >
                              <span>{{ v.createTime }}</span>
                            </div>
                            <div class="message_title">{{ v.title }}</div>
                          </div>
                        </div>
                        <div class="message_text" v-html="v.content"></div>
                      </div>
                    </div>
                    <div class="bgnull" v-if="messageList.length == 0">
                      <div class="bg"></div>
                      <div class="span">暂无消息</div>
                    </div>
                    <div class="message_footer" v-if="messageList">
                      <span @click="checkAll">查看全部</span>
                    </div>
                  </div>
                </div>
                <div
                  :class="pshow ? 'checked information' : 'information'"
                  @mouseover="jg"
                  @mouseleave="lk"
                >
                  <span class="line"></span>

                  <span>{{ username }}</span>
                  <div
                    class="img"
                    :style="imgObj"
                    style="margin-right: 50px"
                  ></div>
                  <div
                    class="card"
                    v-if="pshow"
                    @mouseover="jg"
                    @mouseleave="lk"
                  >
                    <router-link
                      :to="v.url"
                      tag="p"
                      v-for="(v, k) in settings"
                      :key="k"
                      active-class="checked"
                      >{{ v.name }}</router-link
                    >
                    <p @click="logout">登出</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-header>
        <el-header v-if="edd" style="padding: 0;    display: contents" height="50px">
          <div class="headers" style="height: 50px;background-color: #ffffff;border-bottom:1px solid #e9e9ef">
            <div class="logo" style="margin-left: 50px">
              <img src="../../assets/img/backlogo.png" />
            </div>
            <div>
              <el-dropdown @command="addCommand">
                  <div class="icon">
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </div>

                <el-dropdown-menu slot="dropdown">
                  <div>
                    <el-dropdown-item command="a"> 返回首页 </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <div id="co_pe">
              <div class="company"></div>
              <div class="personal" style="margin-right:85px">
                <div class="company" style="border-left:0">
                  <span style="color:#303140;    margin-right: 13px;">{{ currentCompany }}</span>
                  <span class="line" style="line-height:16px;height: 18px;background-color: #e9e9ef;margin-left:0;    margin-right: 13px;"></span>
                  <div class="companylist"></div>
                </div>
                  <span style="color:#303140">{{ username }}</span>
                    <el-dropdown
        placement="bottom"
        size="small"
        @command="operate"
      >
        <span class="el-dropdown-link">
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
        
          <el-dropdown-item :command="{ flag: 2 }">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
                </div>
              </div>
            </div>
        </el-header>
        <el-container class="main">
          <el-main>
            <router-view />
          </el-main>
        </el-container>
      </el-container>
      <ssg-messagebox
        titles="添加企业"
        v-if="maskshow && masktype == 'replace'"
        height="auto"
        width="570px"
        @sub="vsub"
        @shut="qk"
      >
        <div class="form">
          <el-form
            label-width="100px"
            ref="form"
            :rules="rules"
            :model="form"
            label-position="right"
          >
            <el-form-item label="企业名称" prop="companyName">
              <el-input
                v-model="form.companyName"
                placeholder="请输入企业名称"
                maxlength="40"
              ></el-input>
            </el-form-item>
            <el-form-item label="行业类别" prop="industry">
              <el-input
                v-model="form.industry"
                placeholder="请输入行业类别"
                @focus="ishow"
              />
            </el-form-item>
          </el-form>
        </div>
      </ssg-messagebox>
      <div class="mask" @click="hidemask" v-if="inshow == true">
        <div class="industrydiv" @click="hideindu($event)">
          <div class="industrydiv_top">
            <div class="header">
              <div class="h4">
                <h4>所属行业</h4>
              </div>
              <div class="shut">
                <div @click="onshut"></div>
              </div>
            </div>
            <div class="search">
              <div class="searchinput">
                <div class="in_boxs">
                  <div class="in_box" v-if="checkindividual != ''">
                    <div
                      class="text"
                      :style="'width:' + checkindividual.length * 12 + 'px'"
                    >
                      {{ checkindividual }}
                    </div>
                    <span @click="deletein(checkindividual)">×</span>
                  </div>
                </div>
                <input
                  type="text"
                  placeholder="请输入职业名称"
                  v-model="searchtext"
                />
                <div class="searchbg"></div>
              </div>
              <div class="searchresult" v-if="searchtext != ''">
                <ul>
                  <li
                    v-for="(v, k) in get_list"
                    :key="k"
                    v-if="v.indexOf(searchtext) != -1"
                    :class="v == checkindividual ? 'exist' : ''"
                    @click="oncheck(v)"
                  >
                    {{ v }}
                  </li>
                </ul>
              </div>
              <button @click="onindustry">确定</button>
            </div>
          </div>
          <div class="industry_main">
            <div class="industrydiv_left">
              <ul>
                <li
                  v-for="(v, k) in industrylist"
                  :key="k"
                  :class="v.id == checkid ? 'checked' : ''"
                  @click="onchecked(v.id)"
                >
                  <span v-for="(i, j) in v.general.split(',')" :key="j">{{
                    i
                  }}</span>
                </li>
              </ul>
            </div>
            <div class="industrydiv_right">
              <ul
                v-for="(v, k) in industrylist"
                :key="k"
                v-if="v.id == checkid"
              >
                <li
                  v-for="(i, j) in v.individual"
                  :key="j"
                  @click="oncheck(i)"
                  :class="i == checkindividual ? 'checked' : ''"
                >
                  {{ i }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="edit">
      <el-container>
        <SsgMessagebox
          titles="款项金额"
          v-if="maskshow && masktype == 'money'"
          @sub="onmoney"
          width="500px"
          height="auto"
          @shut="onshuts"
        >
          <div class="mtitle">请填写您收到的款项金额</div>
          <div class="minput">
            <el-input v-model="money" type="number"></el-input>
            <span class="left">￥</span>
            <span class="right">元</span>
          </div>
        </SsgMessagebox>

        <div v-if="messageshow">
          <div class="message red" v-if="authState == -1 || authState == 0">
            <div class="info">
              <div class="icon warning"></div>
              <div class="p">
                您尚未认证企业，部分业务功能只能面向认证后的企业用户开放
              </div>
              <div class="a" @click="toIndex">马上认证企业</div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message red" v-if="authState == 3 || authState == 8">
            <div class="info">
              <div class="icon warning"></div>
              <div class="p">{{ mname }}，认证失败</div>
              <div class="a" @click="renewAuth(1)">马上重新认证企业</div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message yellor" v-if="authState == 2">
            <div class="info">
              <div class="p">{{ mname }}，打款中</div>
              <div class="a" @click="oncompany">提交金额</div>
              <div class="a" @click="renewAuth(1)">重新认证</div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message red" v-if="authState == 4 || authState == 5">
            <div class="info">
              <div class="icon key"></div>
              <div class="p">
                我们已经向您公司的账户打了一笔随机数的款项，请将收到的款项数额反馈给我们
              </div>
              <div class="a" @click="oncompany">提交金额</div>
              <div class="a" @click="renewAuth(1)">重新认证</div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message yellor" v-if="authState == 7">
            <div class="info">
              <div class="p">{{ mname }} 线下审核认证中</div>
              <div class="a" @click="amount">查看</div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>
          <div class="message yellor" v-if="authState == 1">
            <div class="info">
              <div class="p">{{ mname }} 审核认证中</div>
              <div class="a" @click="renewAuth(1)">重新认证</div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>

          <div class="message green" v-if="false">
            <div class="info">
              <div class="p">
                您需要去
                <span class="a">设置公司印章</span>，才能为您开启电子签功能
              </div>
            </div>
            <div class="onshut" @click="onmshut">
              <i class="el-icon-close"></i>
            </div>
          </div>
        </div>
        <el-header style="background-color: #f2f5f8" height="63px">
          <div class="headers">
            <div class="logo">
              <img src="../../assets/img/logossg.png" />
            </div>
            <div id="co_pe">
              <div class="company">
                <span>{{ currentCompany }}</span>
                <div class="companylist" @click="goback">
                  <i style="color: #6669e3"></i>
                  <span style="color: #6669e3">返回项目列表</span>
                </div>
              </div>
              <div class="personal">
                <span>{{ projectName }}</span>
              </div>
            </div>
          </div>
        </el-header>
        <el-container class="mains">
          <el-aside width="178px">
            <router-link
              :to="v.router"
              class="submenu"
              tag="div"
              v-for="(v, k) in menu"
              :key="k"
              active-class="checked"
              v-if="checkmenu == v.project"
              replace
            >
              <i :class="v.classname"></i>
              <span>{{ v.name }}</span>
            </router-link>
            <a :href="v.href" class="submenu" v-else>
              <i :class="v.classname"></i>
              <span>{{ v.name }}</span>
            </a>
          </el-aside>
          <el-main>
            <router-view />
          </el-main>
        </el-container>
      </el-container>
      <ssg-messagebox
        titles="添加企业"
        v-if="maskshow && masktype == 'replace'"
        height="auto"
        width="570px"
        @sub="vsub"
        @shut="qk"
      >
        <div class="form">
          <el-form
            label-width="100px"
            ref="form"
            :rules="rules"
            :model="form"
            label-position="right"
          >
            <el-form-item label="企业名称" prop="companyName">
              <el-input
                v-model="form.companyName"
                placeholder="请输入企业名称"
                maxlength="40"
              ></el-input>
            </el-form-item>
            <el-form-item label="行业类别" prop="industry">
              <el-input
                v-model="form.industry"
                placeholder="请输入行业类别"
                @focus="ishow"
              />
            </el-form-item>
          </el-form>
        </div>
      </ssg-messagebox>
      <div class="mask" @click="hidemask" v-if="inshow == true">
        <div class="industrydiv" @click="hideindu($event)">
          <div class="industrydiv_top">
            <div class="header">
              <div class="h4">
                <h4>所属行业</h4>
              </div>
              <div class="shut">
                <div @click="onshut"></div>
              </div>
            </div>
            <div class="search">
              <div class="searchinput">
                <div class="in_boxs">
                  <div class="in_box" v-if="checkindividual != ''">
                    <div
                      class="text"
                      :style="'width:' + checkindividual.length * 12 + 'px'"
                    >
                      {{ checkindividual }}
                    </div>
                    <span @click="deletein(checkindividual)">×</span>
                  </div>
                </div>
                <input
                  type="text"
                  placeholder="请输入职业名称"
                  v-model="searchtext"
                />
                <div class="searchbg"></div>
              </div>
              <div class="searchresult" v-if="searchtext != ''">
                <ul>
                  <li
                    v-for="(v, k) in get_list"
                    :key="k"
                    v-if="v.indexOf(searchtext) != -1"
                    :class="v == checkindividual ? 'exist' : ''"
                    @click="oncheck(v)"
                  >
                    {{ v }}
                  </li>
                </ul>
              </div>
              <button @click="onindustry">确定</button>
            </div>
          </div>
          <div class="industry_main">
            <div class="industrydiv_left">
              <ul>
                <li
                  v-for="(v, k) in industrylist"
                  :key="k"
                  :class="v.id == checkid ? 'checked' : ''"
                  @click="onchecked(v.id)"
                >
                  <span v-for="(i, j) in v.general.split(',')" :key="j">{{
                    i
                  }}</span>
                </li>
              </ul>
            </div>
            <div class="industrydiv_right">
              <ul
                v-for="(v, k) in industrylist"
                :key="k"
                v-if="v.id == checkid"
              >
                <li
                  v-for="(i, j) in v.individual"
                  :key="j"
                  @click="oncheck(i)"
                  :class="i == checkindividual ? 'checked' : ''"
                >
                  {{ i }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "../../libraries/utils/axios.js";
import bgimg from "../../assets/img/avatar.png";

export default {
  name: "SsgMain",
  props: {
    checkmenu: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      imgM: require("@/assets/img/logo.png"),
      projectName: "",
      edit: false,
      edd: false,
      cshow: false,
      pshow: false,
      maskshow: false,
      masktype: "",
      search: "",
      companyList: [],
      oldlist: [],
      currentCompany: "",
      username: "",
      form: {
        companyName: "",
        industry: "",
      },
      rules: {
        companyName: [
          {
            required: true,
            message: "请输入企业名称",
            trigger: "blur",
          },
        ],
        industry: [
          {
            required: true,
            message: "请输入行业类别",
            trigger: "change",
          },
        ],
      },
      menu: [],
      settings: [
        {
          name: "个人设置",
          url: "/main/settings/person",
        },
      ],
      industrylist: [
        {
          id: 15,
          general: "IT,通信,电子,互联网",
          individual: [
            "互联网/电子商务",
            "计算机服务（系统/数据/维护）",
            "计算机硬件",
            "通信/电信运营、增值服务",
            "计算机软件",
            "电子技术/半导体/集成电路",
            "通信/电信/网络设备",
            "网络游戏",
          ],
        },
        {
          id: 16,
          general: "金融业",
          individual: [
            "基金/证券/期货/投资",
            "银行",
            "保险",
            "信托/担保/拍卖/典当",
          ],
        },
        {
          id: 17,
          general: "房地产,建筑业",
          individual: [
            "房地产/建筑/建材/工程",
            "物业管理/商业中心",
            "家居/室内设计/装饰装潢",
          ],
        },
        {
          id: 18,
          general: "商业服务",
          individual: [
            "专业服务/咨询(财会/法律/人力资源等)",
            "中介服务",
            "外包服务",
            "广告/会展/公关/市场推广",
            "检验/检测/认证",
          ],
        },
        {
          id: 19,
          general: "贸易,批发,零售,租赁业 ",
          individual: [
            "快速消费品（食品/饮料/烟酒/日化）",
            "贸易/进出口",
            "租赁服务",
            "耐用消费品（服饰/纺织/皮革/家具/家电等）",
            "零售/批发",
          ],
        },
        {
          id: 20,
          general: "教育,培训",
          individual: ["教育/培训/院校"],
        },
        {
          id: 21,
          general: "生产,加工,制造",
          individual: [
            "汽车/摩托车制造与零配件",
            "加工制造（原料加工/模具）",
            "印刷/包装/造纸",
            "医药/生物工程",
            "航空/航天研究与制造",
            "大型设备/机电设备/重工业",
            "仪器仪表/工业自动化",
            "办公用品及设备",
            "医疗设备/器械",
          ],
        },
        {
          id: 22,
          general: "交通,运输,物流,仓储",
          individual: ["交通/运输/物流/仓储", "航天/航空"],
        },
        {
          id: 23,
          general: "服务业",
          individual: [
            "医疗/护理/美容/保健/卫生服务",
            "旅游/度假/酒店/餐饮",
            "生活服务",
          ],
        },
        {
          id: 24,
          general: "文化,传媒,娱乐,体育",
          individual: ["媒体/出版/影视/文化传播", "娱乐/体育/休闲"],
        },
        {
          id: 25,
          general: "能源,矿产,环保",
          individual: [
            "能源/石油/化工/矿产/地质/采掘/冶炼",
            "电气/电力/水利",
            "环保",
          ],
        },
        {
          id: 26,
          general: "政府,非盈利机构",
          individual: ["政府/公共事业/非盈利机构", "学术/科研"],
        },
        {
          id: 27,
          general: "农,林,牧,渔",
          individual: ["农/林/牧/渔", "跨领域经营"],
        },
        {
          id: 28,
          general: "其他",
          individual: ["其他"],
        },
      ],
      checkid: "1",
      checkindividual: "",
      searchtext: "",
      inshow: false,
      imgObj: "",
      messageshow: false,
      mname: "",
      authId: "",
      companyId: "",
      authState: -1,
      money: "",
      msgShow: false,
      noReadMsgCount: 0,
      messageList: [],
      authzEnable: true,
      msgAllId: "",
    };
  },
  watch: {
    search: function (val, oldval) {
      if (val != "" && this.companyList.length > 0) {
        var newList = [];
        for (var i = 0; i < this.companyList.length; i++) {
          var comname = this.companyList[i].companyname;
          if (comname.indexOf(val) > -1) {
            newList.push(this.companyList[i]);
          }
        }
        this.companyList = newList;
      } else {
        this.companyList = this.oldlist;
      }
    },
    "$route": function(val, oldVal) {  
        if (window.location.href.includes("ssgBacktone")) {
           this.edd = true;
         }else{
           this.edd = false;

         }  
      },
      deep: true,
    
  },
  computed: {
    get_list: function () {
      var arr = [];
      this.industrylist.forEach((c) =>
        c.individual.forEach((t) => arr.push(t))
      );
      return arr;
    },
  },
  created() {
    
    if (window.location.href.includes("hrm")) {
      this.edit = true;
    }
    if (window.location.href.includes("ssgBacktone")) {
      this.edd = true;
    }
    this.loadUserInfo();

    this.getMessageList();

    if (this.edit) {
      this.loadPermissionMenus();
    }
  },
  mounted() {
    if (window.location.href.includes("ssgBacktone")) {
      this.edd = true;
    }
    var _this = this;

    this.$root.$on("onuser", function (val) {
      _this.loadUserInfo();
    });
    this.$root.$on("updateMsg", function (val) {
      _this.getMessageList();
    });
  },
  methods: {
    operate(command) {
      if (command.flag == 2) {
      return axios.post("login/logout")
        .then((res) => {
          this.$message.success(res.data.message);
          this.$router.push({
            path: "/login",
          });
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
      }
    },
    addCommand(command) {
      if (command == "a") {
        window.location.href =
          process.env.VUE_APP_BASEURLSERVICEMAIN + "#/main";
      }
    },
    goback() {
      window.location.href = axios.defaults.baseURL2 + "#/ssgSplat";
    },
    loadCompanyList() {
      axios.get("/loadCompany").then((res) => {
        this.companyList = res.data;
        this.oldlist = res.data;
        for (var i = 0; i < res.data.length; i++) {
          if (res.data[i].cur == "1") {
            this.currentCompany = res.data[i].companyname;
          }
        }
      });
    },
    loadUserInfo() {
      axios.get("/person/queryIndexData")
        .then((res) => {
          //当前用户已登录
          this.username = res.data.data.userName;
          this.currentCompany = res.data.data.companyName;
          this.noReadMsgCount = res.data.data.noticeWDCount;
          if (res.data.data.portrait) {
            this.imgObj = {
              "background-image": "url(" + res.data.data.portrait + ")",
              "background-size": "40px",
              "background-repeat": "no-repeat",
              "background-position": "center",
            };
          } else {
            this.imgObj = {
              "background-image": "url(" + bgimg + ")",
              "background-size": "40px",
              "background-repeat": "no-repeat",
              "background-position": "center",
            };
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    loadPermissionMenus() {
      axios.get("/assist/permission/menu/").then((res) => {
        this.menu = res.data.data.menuList;
        this.projectName = res.data.data.projectName;
        sessionStorage.clear();
        sessionStorage.setItem("btnPermissions", res.data.data.permissionList);
      });
    },
    logout() {
      return axios
        .post("login/logout")
        .then((res) => {
          this.$message.success(res.data.message);
          this.$router.push({
            path: "/login",
          });
        })
        .catch((err) => {
          //处理错误
          console.error(err);
        });
    },
    switchCompany(item) {
      axios
        .get("/switchCompany?_c=" + encodeURIComponent(item))
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.success("企业切换成功");
            this.loadCompanyList();
            this.loadUserInfo();
            this.loadPermissionMenus();
            this.onstatus();
            this.cshow = false;
            this.$router.push({
              path: "/home",
            });
          }
        });
    },
    addCompany() {
      this.maskshow = true;
      this.masktype = "replace";
    },
    vsub() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.industry) {
            this.$message.warning("请选择行业");
            return;
          }
          axios
            .post("/users/create_company", this.form)
            .then((res) => {
              if (res.data.status === 1) {
                this.$message.success(res.data.message);
                this.maskshow = false;
                this.masktype = "";
                this.qk();
                this.switchCompany(res.data.companyId);
              } else {
                this.$message.error(res.data.message);
              }
            })
            .catch(function (err) {
              this.qk();
              this.$message.error("添加企业失败");
            });
        }
      });
    },
    oncard(e) {
      e.stopPropagation();
      if (!this.cshow) {
        this.cshow = true;
        document.addEventListener("click", this.hidePanel, false);
      } else {
        this.cshow = false;
      }
    },
    hidePanel() {
      this.cshow = false;
      document.removeEventListener("click", this.hidePanel, false);
    },
    cardstatus(e) {
      e.stopPropagation();
    },
    jg() {
      this.pshow = true;
    },
    lk() {
      this.pshow = false;
    },
    onchecked(id) {
      this.checkid = id;
    },
    oncheck(i) {
      this.checkindividual = i;
      this.searchtext = "";
    },
    deletein() {
      this.checkindividual = "";
    },
    onshut() {
      this.inshow = false;
      this.checkindividual = "";
    },
    onindustry() {
      this.form.industry = this.checkindividual;
      this.inshow = false;
    },
    hidemask() {
      this.inshow = false;
      this.checkindividual = "";
    },
    hideindu(e) {
      e.stopPropagation();
    },
    ishow() {
      this.inshow = true;
    },
    qk() {
      this.form.companyName = "";
      this.form.industry = "";
      this.checkindividual = "";
    },

    onstatus() {
    },

    onmshut() {
      this.messageshow = false;
    },

    toIndex() {
      this.$router.push({
        path: "/index",
      });
    },

    renewAuth(num) {
      const param = {};
      param.id = this.authId;
      param.companyId = this.companyId;
    },

    oncompany() {
      this.maskshow = true;
      this.masktype = "money";
    },

    toCerts(state) {
      const param = {};
      param.authId = this.authId;
      param.companyId = this.companyId;
      param.companyName = this.mname;
      let toPage = "Index";
      if (state === 0) {
        toPage = "LicenceCllect";
      } else if (state === 1) {
        toPage = "AccountCllect";
      }
      this.$router.push({
        name: toPage,
        query: param,
      });
    },

    onmoney() {
      if (this.money) {
        const params = {};
        params.id = this.authId;
        params.companyId = this.companyId;
        params.cash = this.money;
        axios.post("/companyAuth/validCash", params).then((res) => {
          if (res.data.status == 1) {
            this.$message.success("企业实名认证成功");
            this.onstatus();
            this.onshuts();
          } else {
            this.$message.error(res.data.message);
          }
        });
      } else {
        this.$message.warning("请填写您收到的款项金额");
      }
    },

    amount() {
      this.$router.push({
        path: "/setting/company",
      });
    },

    onshuts() {
      this.maskshow = false;
      this.masktype = "";
    },

    msg_show() {
      this.msgShow = true;
    },

    msg_hidden() {
      this.msgShow = false;
    },
    markAsRead() {
      axios.post("/person/updateNoticeStatus").then((res) => {
        if (res.data.status == 1) {
          this.getMessageList();
        }
      });
    },

    getMessageList() {
      let that = this;
      axios.get("/person/queryNoticeWDList?pageNum=1&pageSize=3")
        .then((res) => {
          that.messageList = res.data.data.list;
        });
    },
    //查看全部
    checkAll() {
      this.$router.push({
        path: "/main/settings/messageList",
        query: {},
      });
    },
    openDetail(type, messageId, category, id) {
      let that = this;
      axios.post("/message/updateReadStatus?ids=" + id).then((res) => {
        that.getMessageList();
        if (res.data.status == 1) {
          if (type == 3) {
            that.$router.push({
              path: "/message/systemPlacard",
              query: {
                origin: "messageList",
                id: id,
              },
            });
            that.msg_hidden();
          } else if (type == 1) {
            that.$router.push({
              path: "/message/systemMsg",
              query: {
                origin: "messageList",
                messageId: messageId,
                category: category,
              },
            });
            that.msg_hidden();
          } else if (type == 2) {
            that.$router.push({
              path: "/setting/bill",
              query: {},
            });
            that.msg_hidden();
          }
        }
      });
    },
  },
};
</script>

<style  scoped lang="less">
.el-container {
  height: 100%;
}
.el-main {
  height: calc(100% - 60px);
}

.el-header {
  width: 100%;

  .headers {
    width: 100%;
    height: 63px;
    display: flex;
    align-items: center;
    background-color: #f2f5f8;

    .logo {
      // min-width: 147px;
      height: 44px;
      margin-left: 6px;
      margin-right: 5px;
    }
    .icon {
      margin: 10px auto;
      width: 20px;
      height: 20px;
      background: #ffffff;
      border-radius: 4px;
      border: 1px solid #d8dae1;
      margin-left: 20px;
      i {
        margin: 3px;
      }
    }

    #co_pe {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    #co_pe .company {
      border-left: 1px solid #a4a5ad;
      padding-left: 38px;
      display: flex;
    }

    #co_pe .companylist {
      display: flex;
      align-items: center;
      position: relative;
    }

    .cheader {
      padding: 20px 20px 0 20px;
      border-bottom: 1px solid #e9eff4;
    }

    #co_pe .companylist .card {
      position: absolute;
      width: 300px;
      top: 45px;
      left: 50%;
      margin-left: -130px;
      z-index: 100;
      box-shadow: 2px 2px 6px rgba(222, 225, 228, 0.5),
        2px -2px 6px rgba(222, 225, 228, 0.5),
        -2px 2px 6px rgba(222, 225, 228, 0.5),
        -2px -2px 6px rgba(222, 225, 228, 0.5);
      box-sizing: border-box;
      border-radius: 8px;
      background-color: #fff;
    }

    #co_pe .companylist .ctitle {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    #co_pe .companylist .ctitle span {
      font-size: 14px;
      color: #6669e3;
      margin: 0;
      background-image: url(../../assets/img/add_bg.png);
      background-repeat: no-repeat;
      background-size: 12px;
      background-position: left center;
      padding-left: 15px;
    }

    #co_pe .companylist .ctitle h4 {
      font-size: 14px;
      font-weight: bold;
    }

    #co_pe .companylist .input {
      width: 100%;
      height: 34px;
      margin: 13px 0 16px;
    }

    #co_pe .companylist .input input {
      width: 100%;
      height: 32px;
      border: 1px solid #d9dbe2;
      border-radius: 6px;
      padding: 0 30px 0 15px;
      box-sizing: border-box;
      background-image: url(../../assets/img/ss.png);
      background-repeat: no-repeat;
      background-position: right 10px center;
      background-size: 16px;
    }

    #co_pe .companylist .card .list {
      width: 100%;
      max-height: 200px;
      padding: 0 25px;
      background-color: #f8fafb;
      box-sizing: border-box;
      padding-bottom: 10px;
      overflow: auto;

      p {
        font-size: 14px;
        padding-top: 10px;
        cursor: pointer;
      }
    }

    #co_pe .company span {
      font-size: 14px;
      font-weight: 500;
      margin-right: 23px;
      cursor: pointer;
    }

    #co_pe .company i {
      width: 18px;
      height: 14px;
      display: block;
      background-image: url(../../assets/img/qiehuan_bg.png);
      cursor: pointer;
    }

    #co_pe .company i:hover {
      background-image: url(../../assets/img/qiehuan_bg.png);
    }

    #co_pe .company .checked {
      background-image: url(../../assets/img/qiehuan_bg.png);
    }

    #co_pe .personal {
      margin-right: 15px;
      display: flex;
      align-items: center;
    }

    #co_pe .personal .news {
      font-size: 20px;
      // margin-right: 27px;
      position: relative;
      padding: 15px 0 20px 10px;
      .item {
        cursor: pointer;
      }
      .message_header {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #e9eff4;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        padding: 0 25px 0 20px;
        align-items: center;
        .header_title {
          color: #303140;
          font-size: 16px;
          font-weight: bolder;
        }
        .header_operate {
          color: #6669e3;
          font-size: 14px;
          .mark_read,
          .message_set {
            cursor: pointer;
            font-weight: bolder;
          }
        }
      }

      .bgnull {
        width: 100%;
        padding-bottom: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .bg {
          width: 214px;
          height: 110px;
          background-image: url(../../assets/img/10wvB0eE.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 214px 110px;
          margin-top: 100px;
        }
        .span {
          font-size: 14px;
          color: #8a8a9a;
          padding: 10px 0;
        }
      }
      .message_footer {
        text-align: center;
        border-top: 1px solid #e9eff4;
        padding: 5px 0;
        span {
          color: #6669e3;
          font-size: 16px;
          cursor: pointer;
        }
      }
      .card {
        position: absolute;
        width: 430px;
        margin-left: -243px;
        background-color: #fff;
        top: 63px;
        z-index: 1000;
        border-radius: 8px;
        padding: 7px 0;
        box-shadow: 2px 2px 6px rgba(222, 225, 228, 0.5),
          2px -2px 6px rgba(222, 225, 228, 0.5),
          -2px 2px 6px rgba(222, 225, 228, 0.5),
          -2px -2px 6px rgba(222, 225, 228, 0.5);
        p {
          width: 100%;
          text-align: center;
          font-size: 14px;
          // margin-top: 13px;
          padding: 6px 0;
          cursor: pointer;
        }

        p:hover {
          background-color: #f2f5f8;
        }
      }
    }

    #co_pe .personal .news .el-badge__content {
      width: 17px;
      height: 17px;
      line-height: 17px;
      padding: 0;
      border-radius: 50px;
      border: 0;
      top: 10px;
      right: 8px;
    }

    #co_pe .personal .information {
      height: 63px;
      display: flex;
      align-items: center;
      position: relative;
    }

    #co_pe .personal .checked {
      span {
        color: #6669e3;
      }

      .img {
        border: 1px solid #6669e3 !important;
      }
    }

    #co_pe .personal .information span {
      margin-right: 15px;
      font-size: 14px;
    }

    #co_pe .personal .information .img {
      width: 38px;
      height: 38px;
      border-radius: 50px;
      border: 1px solid #f2f5f8;

      img {
        width: 38px;
        height: 38px;
      }
    }

    #co_pe .personal .information .card {
      position: absolute;
      width: 100px;
      left: 50%;
      margin-left: -50px;
      background-color: #fff;
      top: 63px;
      // z-index: 999;
      border-radius: 8px;
      padding: 7px 0;
      box-shadow: 2px 2px 6px rgba(222, 225, 228, 0.5),
        2px -2px 6px rgba(222, 225, 228, 0.5),
        -2px 2px 6px rgba(222, 225, 228, 0.5),
        -2px -2px 6px rgba(222, 225, 228, 0.5);
      p {
        width: 100%;
        text-align: center;
        font-size: 14px;
        // margin-top: 13px;
        padding: 6px 0;
        cursor: pointer;
      }

      p:hover {
        background-color: #f2f5f8;
      }
    }
  }
  .header {
    background-color: #ffffff;
    position: fixed;
    top: 0;
    z-index: 999;
    border-bottom: 1px solid #d9dbe2;
    width: 100%;
    height: 63px;
    display: flex;
    align-items: center;

    .logo {
      // height: 44px;
      margin-left: 6px;
      img {
        // width: 122px;
        // height: 44px;
      }
    }

    #co_pe {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    #co_pe .company {
      // border-right: 1px solid #a4a5ad;
      // padding-left: 15px;
      // display: flex;
    }

    #co_pe .companylist {
      display: flex;
      align-items: center;
      position: relative;
    }

    .cheader {
      padding: 20px 20px 0 20px;
      border-bottom: 1px solid #e9eff4;
    }

    #co_pe .companylist .card {
      position: absolute;
      width: 300px;
      top: 45px;
      left: 50%;
      margin-left: -130px;
      // z-index: 100;
      box-shadow: 2px 2px 6px rgba(222, 225, 228, 0.5),
        2px -2px 6px rgba(222, 225, 228, 0.5),
        -2px 2px 6px rgba(222, 225, 228, 0.5),
        -2px -2px 6px rgba(222, 225, 228, 0.5);
      box-sizing: border-box;
      border-radius: 8px;
      background-color: #fff;
    }

    #co_pe .companylist .ctitle {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    #co_pe .companylist .ctitle span {
      font-size: 14px;
      color: #6669e3;
      margin: 0;
      background-image: url(../../assets/img/add_bg.png);
      background-repeat: no-repeat;
      background-size: 12px;
      background-position: left center;
      padding-left: 15px;
    }

    #co_pe .companylist .ctitle h4 {
      font-size: 14px;
      font-weight: bold;
    }

    #co_pe .companylist .input {
      width: 100%;
      height: 34px;
      margin: 13px 0 16px;
    }

    #co_pe .companylist .input input {
      width: 100%;
      height: 32px;
      border: 1px solid #d9dbe2;
      border-radius: 6px;
      padding: 0 30px 0 15px;
      box-sizing: border-box;
      background-image: url(../../assets/img/ss.png);
      background-repeat: no-repeat;
      background-position: right 10px center;
      background-size: 16px;
    }

    #co_pe .companylist .card .list {
      width: 100%;
      max-height: 200px;
      padding: 0 25px;
      background-color: #f8fafb;
      box-sizing: border-box;
      padding-bottom: 10px;
      overflow: auto;

      p {
        font-size: 14px;
        padding-top: 10px;
        cursor: pointer;
        // 					overflow:hidden;
        // 					text-overflow:ellipsis;
        // 					white-space:nowrap;
      }
    }

    #co_pe .company span {
      font-size: 14px;

      font-weight: bold;
      color: #303140;
      // margin-right: 23px;
      cursor: pointer;
      vertical-align: middle;
    }

    #co_pe .company i {
      width: 18px;
      height: 14px;
      display: block;
      background-image: url(../../assets/img/qiehuan.png);
      cursor: pointer;
    }

    #co_pe .company i:hover {
      background-image: url(../../assets/img/qiehuan_bg.png);
    }

    #co_pe .company .checked {
      background-image: url(../../assets/img/qiehuan_bg.png);
    }

    #co_pe .personal {
      margin-right: 15px;
      display: flex;
      align-items: center;
    }

    #co_pe .personal .news {
      font-size: 20px;
      // margin-right: 27px;
      position: relative;
      padding: 15px 0 15px 12px;
      .item {
        cursor: pointer;
      }
      .message_header {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #e9eff4;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        padding: 0 25px 0 20px;
        align-items: center;
        .header_title {
          color: #303140;
          font-size: 16px;
          font-weight: bolder;
        }
        .header_operate {
          color: #6669e3;
          font-size: 14px;
          .mark_read,
          .message_set {
            cursor: pointer;
            font-weight: bolder;
          }
        }
      }
      .message_content {
        padding: 0 25px;
        max-height: 300px;
        overflow: auto;
        .message_section {
          padding: 15px 0;
          border-bottom: 1px solid #e9eff4;
          .message_topContent {
            display: flex;
            margin-bottom: 12px;
            .message_icon {
              width: 40px;
              height: 40px;
              padding-top: 3px;
            }
            .message_type {
              width: 300px;
              color: #8a8a9a;
              font-size: 14px;
              padding-left: 14px;
              .system_name {
                padding-bottom: 5px;
                display: flex;
                justify-content: space-between;
              }
              .message_title {
                color: #303140;
                font-size: 14px;
              }
            }
          }
          .message_text {
            color: #8a8a9a;
            font-size: 12px;
            padding-bottom: 15px;
            padding-left: 56px;
          }
          .message_check {
            color: #6669e3;
            font-size: 14px;
            text-align: right;
            padding-left: 64px;
            cursor: pointer;
          }
        }
        .message_section:last-child {
          border: none;
        }
      }
      .bgnull {
        width: 100%;
        padding-bottom: 50px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .bg {
          width: 214px;
          height: 110px;
          background-image: url(../../assets/img/10wvB0eE.png);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 214px 110px;
          margin-top: 100px;
        }
        .span {
          font-size: 14px;
          color: #8a8a9a;
          padding: 10px 0;
        }
      }
      .message_footer {
        text-align: center;
        border-top: 1px solid #e9eff4;
        padding: 5px 0;
        span {
          color: #6669e3;
          font-size: 16px;
          cursor: pointer;
        }
      }
      .card {
        position: absolute;
        width: 430px;
        margin-left: -243px;
        background-color: #fff;
        top: 50px;
        z-index: 1000;
        border-radius: 8px;
        padding: 7px 0;
        box-shadow: 2px 2px 6px rgba(222, 225, 228, 0.5),
          2px -2px 6px rgba(222, 225, 228, 0.5),
          -2px 2px 6px rgba(222, 225, 228, 0.5),
          -2px -2px 6px rgba(222, 225, 228, 0.5);
        p {
          width: 100%;
          text-align: center;
          font-size: 14px;
          // margin-top: 13px;
          padding: 6px 0;
          cursor: pointer;
        }

        p:hover {
          background-color: #f2f5f8;
        }
      }
    }

    #co_pe .personal .news .el-badge__content {
      width: 17px;
      height: 17px;
      line-height: 17px;
      padding: 0;
      border-radius: 50px;
      border: 0;
      top: 10px;
      right: 8px;
    }

    #co_pe .personal .information {
      height: 63px;
      display: flex;
      align-items: center;
      position: relative;
    }

    #co_pe .personal .checked {
      span {
        color: #6669e3;
      }

      .img {
        border: 1px solid #6669e3 !important;
      }
    }

    #co_pe .personal .information span {
      margin-right: 15px;
      font-size: 14px;
    }

    #co_pe .personal .information .img {
      width: 38px;
      height: 38px;
      border-radius: 50px;
      border: 1px solid #f2f5f8;

      img {
        width: 38px;
        height: 38px;
      }
    }

    #co_pe .personal .information .card {
      position: absolute;
      width: 100px;
      left: 50%;
      margin-left: -50px;
      background-color: #fff;
      top: 63px;
      z-index: 999;
      border-radius: 8px;
      padding: 7px 0;
      box-shadow: 2px 2px 6px rgba(222, 225, 228, 0.5),
        2px -2px 6px rgba(222, 225, 228, 0.5),
        -2px 2px 6px rgba(222, 225, 228, 0.5),
        -2px -2px 6px rgba(222, 225, 228, 0.5);
      p {
        width: 100%;
        text-align: center;
        font-size: 14px;
        // margin-top: 13px;
        padding: 6px 0;
        cursor: pointer;
      }

      p:hover {
        background-color: #f2f5f8;
      }
    }
  }
}

.form {
  padding-top: 32px;
}

.el-aside {
  padding-top: 46px;

  .submenu {
    width: 100%;
    height: 42px;
    display: flex;
    align-items: center;
    padding: 0 32px;
    box-sizing: border-box;
    cursor: pointer;

    i {
      width: 20px;
      height: 20px;
      margin-right: 16px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 20px;
    }

    .home {
      background-image: url(../../assets/img/home.png);
    }

    .recruitment {
      background-image: url(../../assets/img/recruitment.png);
    }

    .organization {
      background-image: url(../../assets/img/organization.png);
    }

    .staff {
      background-image: url(../../assets/img/menu/staff.png);
    }

    .salary {
      background-image: url(../../assets/img/menu/salary.png);
    }

    .mysign {
      background-image: url(../../assets/img/menu/mysign.png);
    }

    .calculate {
      background-image: url(../../assets/img/menu/calculate.png);
    }

    .attendance {
      background-image: url(../../assets/img/menu/attendance.png);
    }

    .notice {
      background-image: url(../../assets/img/menu/notice.png);
    }

    span {
      font-size: 14px;
      color: #000;
    }
  }

  .checked {
    background-color: #6669e3;
    color: #fff;

    .home {
      background-image: url(../../assets/img/menu/home_b.png);
    }

    .recruitment {
      background-image: url(../../assets/img/menu/recruitment_b.png);
    }

    .organization {
      background-image: url(../../assets/img/menu/organization_b.png);
    }

    .staff {
      background-image: url(../../assets/img/menu/staff_b.png);
    }

    .salary {
      background-image: url(../../assets/img/menu/salary_b.png);
    }

    .mysign {
      background-image: url(../../assets/img/menu/mysign_b.png);
    }

    .calculate {
      background-image: url(../../assets/img/menu/calculate_b.png);
    }

    .attendance {
      background-image: url(../../assets/img/menu/attendance_b.png);
    }

    .notice {
      background-image: url(../../assets/img/menu/notice_b.png);
    }

    span {
      color: #fff;
    }
  }
}

.main {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: auto;

  .el-aside {
    height: 100%;
  }

  .el-main {
    width: 100%;
    min-width: 1086px;
    padding: 0;
    height: 100%;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px 6px 0 0;
    // border: 1px solid #d9dbe2;

    flex: 1;
    flex-basis: auto;
    // overflow: hidden;
    box-sizing: border-box;
    padding: 0px;
  }
}
.mains {
  display: flex;
  width: 100%;
  height: 100%;
  // 		position: absolute;
  // 		top: 63px;
  //		left: 0;
  //		right: 0;
  //		bottom: 0;
  overflow: auto;
  background-color: #f2f5f8;
  .el-aside {
    height: 100%;
  }

  .el-main {
    width: 100%;
    min-width: 1086px;
    padding: 0;
    margin-right: 16px;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px 6px 0 0;
    border: 1px solid #d9dbe2;
    height: calc(100vh - 60px);
  }
}

.mask {
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  z-index: 15000;
  overflow: hidden;
}

.industrydiv {
  width: 720px;
  height: 508px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -254px;
  margin-left: -360px;
  border-radius: 6px;
}

.industrydiv .industrydiv_top {
  width: 100%;
  height: 110px;
  border-bottom: 1px solid #dfdfdf;
  padding: 0 25px;
  box-sizing: border-box;
}

.industrydiv .industrydiv_top .header {
  width: 100%;
  height: 57px;
  display: flex;
  align-items: center;
}

.industrydiv .industrydiv_top .header .h4 {
  width: 50%;
}

.industrydiv .industrydiv_top .header .h4 h4 {
  font-size: 18px;
  font-weight: bold;
}

.industrydiv .industrydiv_top .header .shut {
  width: 50%;
  display: flex;
  flex-direction: row-reverse;
}

.industrydiv .industrydiv_top .header .shut div {
  width: 12px;
  height: 12px;
  background-image: url(../../assets/img/cha.png);
  background-size: cover;
  cursor: pointer;
}

.industrydiv .industrydiv_top .search {
  width: 100%;
  height: 34px;
  display: flex;
  align-items: center;
  position: relative;
}

.industrydiv .industrydiv_top .search .searchinput {
  width: 570px;
  height: 34px;
  box-sizing: border-box;
  border: 1px solid #bfbfbf;
  border-radius: 6px;
  padding: 0 5px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-right: 14px;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs {
  display: flex;
  align-items: center;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs .in_box {
  width: auto;
  display: flex;
  align-items: center;
  height: 22px;
  background-color: #6669e3;
  color: #fff;
  padding: 0 5px;
  border-radius: 4px;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs .in_box .text {
  height: 22px;
  line-height: 22px;
  text-align: center;
  font-size: 12px;
}

.industrydiv .industrydiv_top .search .searchinput .in_boxs .in_box span {
  cursor: pointer;
  font-size: 18px;
}

.industrydiv .industrydiv_top .search .searchinput input {
  width: 570px;
  height: 32px;
  border-radius: 6px;
  border: none;
  margin: 0 8px;
  box-sizing: border-box;
  font-size: 14px;
  background-image: url(../../assets/img/ss.png);
  background-size: 16px;
  background-repeat: no-repeat;
  background-position: right center;
}

.industrydiv .industrydiv_top .search button {
  border: none;
  height: 34px;
  padding: 0 15px;
  border-radius: 6px;
  min-width: 84px;
  color: #fff;
  font-size: 14px;
  background-color: #6669e3;
  cursor: pointer;
  float: right;
}

.industrydiv .industrydiv_top .search button:hover {
  background-color: #8285ff;
}

.industrydiv .industrydiv_top .search button:active {
  background-color: #5658c5;
}

.industrydiv .industrydiv_top .search .searchresult {
  width: 568px;
  overflow: auto;
  max-height: 200px;
  background-color: #fff;
  position: absolute;
  top: 33px;
  left: 0;
  border: 1px solid #bfbfbf;
}

.industrydiv .industrydiv_top .search .searchresult ul {
  width: 100%;
  box-sizing: border-box;
}

.industrydiv .industrydiv_top .search .searchresult ul li {
  font-size: 14px;
  padding: 13px;
}

.industrydiv .industrydiv_top .search .searchresult ul li:hover {
  background-color: #f8f8f8;
}

.industrydiv .industrydiv_top .search .searchresult ul .exist {
  color: #6669e3;
}

.industrydiv .industry_main {
  width: 100%;
  height: 395px;
  box-sizing: border-box;
  display: flex;
}

.industrydiv .industry_main .industrydiv_left {
  width: 215px;
  height: 100%;
  padding-left: 26px;
  box-sizing: border-box;
}

.industrydiv .industry_main .industrydiv_left ul {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-top: 20px;
  box-sizing: border-box;
}

.industrydiv .industry_main .industrydiv_left ul li {
  margin-bottom: 13px;
  cursor: pointer;
}

.industrydiv .industry_main .industrydiv_left ul li span {
  display: inline-block;
  height: 14px;
  line-height: 14px;
  border-right: 1px solid #bfbfbf;
  padding: 0 6px;
  color: #8b8b8b;
  font-size: 14px;
}

.industrydiv .industry_main .industrydiv_left ul li span:last-child {
  border-right: none;
}

.industrydiv .industry_main .industrydiv_left ul li span:first-child {
  padding-left: 0;
}

.industrydiv .industry_main .industrydiv_left ul .checked {
  background-image: url(../../assets/img/bg_yellor.png);
  background-size: 7px auto;
  background-repeat: no-repeat;
  background-position: 178px center;
}

.industrydiv .industry_main .industrydiv_left ul .checked span {
  font-weight: bold;
  color: #000000;
}

.industrydiv .industry_main .industrydiv_right {
  width: 505px;
  height: 100%;
  background-color: #f2f2f5;
}

.industrydiv .industry_main .industrydiv_right ul {
  width: 100%;
  // height: 100%;
  box-sizing: border-box;
  padding: 20px 25px;
  font-size: 14px;
  display: flex;
  flex-wrap: wrap;
}

.industrydiv .industry_main .industrydiv_right ul li {
  // display: inline-block;
  width: 45%;
  margin-bottom: 12px;
  cursor: pointer;
  height: 40px;
  margin-right: 10px;
}

.industrydiv .industry_main .industrydiv_right ul .checked {
  color: #6669e3;
}

.message {
  width: 100%;
  height: 35px;
  border-radius: 6px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;

  .info {
    display: flex;
    align-items: center;

    .icon {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      overflow: hidden;
      background-size: 20px;
      background-position: center;
      background-repeat: no-repeat;
      margin-right: 10px;
    }

    .key {
      background-image: url(../../assets/img/keybg.png);
    }

    .warning {
      background-image: url(../../assets/img/1_19.png);
    }

    .a {
      color: #6669e3;
      cursor: pointer;
      margin-left: 14px;
    }
  }

  .onshut {
    position: absolute;
    right: 12px;

    i {
      cursor: pointer;
    }
  }
}

.red {
  border: 1px solid #ff6752;
  background-color: #ffe3e1;

  .onshut {
    i {
      color: #ff6752;
    }
  }

  .info {
    font-size: 12px;

    .p {
      color: #ff6752;
    }
  }
}

.yellor {
  border: 1px solid #f6a303;
  background-color: #fffce7;

  .onshut {
    i {
      color: #f6a303;
    }
  }

  .info {
    font-size: 12px;

    .p {
      color: #f6a303;
    }
  }
}

.green {
  border: 1px solid #27a87d;
  background-color: #ddf7ef;

  .onshut {
    i {
      color: #27a87d;
    }
  }

  .info {
    font-size: 12px;

    .p {
      color: #27a87d;
    }

    .a {
      margin-left: 0;
    }
  }
}

.mtitle {
  width: 100%;
  margin: 40px 0 20px;
  font-size: 14px;
}

.minput {
  margin-bottom: 48px;
  position: relative;

  .left {
    top: 6px;
    left: 10px;
    font-size: 14px;
    position: absolute;
  }

  .right {
    top: 6px;
    right: 12px;
    font-size: 14px;
    position: absolute;
  }
}

.minput /deep/ .el-input__inner {
  padding: 0 30px;
}
.line {
  display: inline-block;
  width: 1px;
  height: 16px;
  background-color: #d9dbe2;
  font-weight: bold;
  margin-left: 15px;
}
.serve {
  margin-left: 12px;
  width: 130px;
  vertical-align: middle;
  display: inline-block;
  color: #303140;
  height: 16px;
  font-size: 16px;
  font-weight: bold;
  line-height: 15px;
}
</style>
